import React from 'react';

export function XIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path
                id='Vector'
                d='M15.1972 1L17.9577 1L11.9014 8.62976L19 19L13.4507 19L9.08451 12.7093L4.09859 19H1.33803L7.78873 10.8408L1 1L6.69014 1L10.6338 6.76125L15.1972 1ZM14.2113 17.1626L15.7324 17.1626L5.87324 2.7128L4.23944 2.7128L14.2113 17.1626Z'
                fill='#0078D3'
            />
        </svg>
    );
}
